// extracted by mini-css-extract-plugin
module.exports = {"typingAnimation":"TypingAnimation_typingAnimation__1cL8M","blink":"TypingAnimation_blink__GAK49"};